export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const commonAccordionCustomStyles = {
  width: '100%',
  boxShadow: 'unset',

  '.MuiAccordionSummary-root': {
    flexDirection: 'row-reverse',
    columnGap: '10px',
    color: ({ palette }) => palette.text.secondary,
    '.MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
  },
  '.MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 'unset',
  },
  '.MuiAccordionSummary-expandIconWrapper': {
    color: ({ palette }) => palette.text.secondary,
    backgroundColor: ({ palette }) => palette.background.secondary,
    borderRadius: ({ shape }) => shape.radius.s,
    transform: 'rotate(-90deg)',
    '&.Mui-expanded': {
      transform: 'rotate(0deg)',
    },
  },
  '.accordion-summary-title': {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '22px',
  },
  '.accordion-summary-container': {
    padding: '0 10px',
    marginRight: '12px',
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  '.MuiAccordionDetails-root': {
    paddingBottom: 0,
  },
};
